const en = {
	title: 'Member standard library',
	searchPlaceholder: 'Please enter your name',
	allTeams: 'All teams',
	allMajors: 'All majors',
	memberList: 'Member list',
	waitingToAddMembers: 'Waiting to add members',
	synchronization: 'synchronization',
	noMember: 'No member',
	addMember: 'Add member',
	avatar: 'avatar',
	englishName: 'english name',
	chineseName: 'chinese name',
	cellPhoneNumber: 'cell-phone number',
	mailbox: 'mailbox',
	major: 'major',
	team: 'team',
	cancel: 'cancel',
	confirm: 'confirm',
	search: 'search',
	add: 'add',
	back: 'Back',
	addIbraryMember: 'add standard library member',
};

export default en;
